export default {
  brandSelected: null,
  perPage: 10,
  currentPage: 1,
  totalItems: null,
  pageOptions: [
    5,
    10,
    20,
    50,
    { value: Number.MAX_SAFE_INTEGER, text: "show all" },
  ],
  isLoading: false,
  sort: { key: null, type: false },
  searchText: null,
};
